var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showCode)?_c('div',{attrs:{"id":"codeArea"}},[_c('AceEditor',{attrs:{"value":_vm.code,"lang":"python","theme":"chrome"},on:{"init":_vm.editorInit}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }